var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enheader"},[_c('h3',{staticClass:"headline"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }